import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';

import LabeledField from '@zr/components/Fields/LabeledField';

import FormActions from '../../../components/FormActions';
import QuestionLabel from '../../../components/QuestionLabel';

import IndexedLegend from './IndexedLegend';
import FormButtons from './FormButtons';

const DESCRIPTION = 'description';

export function JobHistory({
  index, onContinue, onSkip, submitButtonText, title, totalScreeningQuestions,
  isInJs6650Test, setIsLoading,
}) {
  const handleContinue = async (values) => {
    // `setIsLoading(true)` so that we can disable the close button while the
    // screen is processing/loading
    setIsLoading(true);
    // job description is special, it will be updated via the suggestion-reply endpoint
    await onContinue(values[DESCRIPTION]);
  };

  return (
    <Formik
      initialValues={{ [DESCRIPTION]: '' }}
      onSubmit={handleContinue}
      validationSchema={Yup.object().shape({
        [DESCRIPTION]: Yup.string().required('Please add a description').min(15, 'Please add at least 15 characters'),
      })}
    >
      {({
        errors, handleChange, handleSubmit, isSubmitting, touched, values,
      }) => (
        <form className="Suggestion" onSubmit={handleSubmit}>
          <fieldset>
            {isInJs6650Test && (
              <QuestionLabel
                as="legend"
                html={title}
                number={index}
                totalQuestions={totalScreeningQuestions}
              />
            )}
            {!isInJs6650Test && (
              <IndexedLegend index={index} text={title} />
            )}
            <LabeledField
              as="textarea"
              input={{
                disabled: isSubmitting,
                maxLength: 255,
                name: DESCRIPTION,
                onChange: handleChange,
                value: values[DESCRIPTION],
              }}
              label="Description (15 character min)"
              meta={{
                error: errors[DESCRIPTION],
                touched: touched[DESCRIPTION],
              }}
              placeholder="Description (15 character min)"
            />
            {isInJs6650Test && (
              <FormActions
                disableContinue={isSubmitting}
                disableSkip={isSubmitting}
                onSkip={onSkip}
                submitButtonText={submitButtonText}
              />
            )}
            {!isInJs6650Test && (
              <FormButtons disabled={isSubmitting} onSkip={onSkip} submitButtonText={submitButtonText} />
            )}
          </fieldset>
        </form>
      )}
    </Formik>
  );
}

JobHistory.propTypes = {
  index: PropTypes.number.isRequired,
  isInJs6650Test: PropTypes.bool,
  onContinue: PropTypes.func.isRequired,
  onSkip: PropTypes.func,
  setIsLoading: PropTypes.func,
  submitButtonText: PropTypes.string,
  title: PropTypes.string.isRequired,
  totalScreeningQuestions: PropTypes.number.isRequired,
};

JobHistory.defaultProps = {
  isInJs6650Test: false,
  onSkip: null,
  setIsLoading: () => {},
  submitButtonText: 'Continue',
};

export default JobHistory;
